import Page from 'components/Page';
import React, {Component} from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
  Button
} from 'reactstrap';

import { FaImage, FaTimes, FaSave, FaTrashAlt} from 'react-icons/fa';

import {validarItem, validarFormulario} from './../utils/validar'; 
import Confirmar from '../components/ModalConfirmar'; 
import Cargando from './../components/Cargando';
import Notificaciones from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from 'utils/constants';

import Utils from './../utils/utils';
import Fecha from './../utils/fecha';
import UrlBase from './../api/UrlBase';

import Botonera from './../components/BotoneraGuardar';
import TablaBlog from './../components/TablaBlog';
import ModalBlog from './../components/ModalBlog';
import ModalBlogGaleria from './../components/ModalBlogGaleria';

import Blog from './../api/Blog';
import Galeria from './../api/Galeria'; 
const blog = new Blog();
const galeria = new Galeria(); 

class GestorBlog extends Component {

    constructor(props){
        super(props);
        this.state = {
            usuario: this.props.user.rut,
            id:'',
            galeria: null,
            estado:'borrador',
            imagen : null,
            titulo:'',
            encabezado:'',
            contenido:'',
            srcImg:'',
            data:[],
            entrada:[],
            galerias:[],
            modal:false,
            modal2: false,
            largotitulo:0,
            largoencabezado:0,
            largocontenido:0,

            cargando:true,
            validacion:{
                titulo:false,
                encabezado:false,
                contenido:false,
            },
            confirmarGuardar: false,
            confirmarEditar: false, 
            confirmarBorrar: false,
            idBorrar:'',
            imagenesGaleria:[],
            titulosUrl:[]
        }
    }

    estadoDefault = () =>{
        document.getElementById('input').value = null;
        this.setState({
            usuario: this.props.user.rut,
            id:'',
            galeria: null,
            estado:'borrador',
            imagen : null,
            titulo:'',
            encabezado:'',
            contenido:'',
            srcImg:'',
            entrada:[],
            galerias:[],
            modal:false,
            modal2: false,
            largotitulo:0,
            largoencabezado:0,
            largocontenido:0,

            cargando:false,
            validacion:{
                titulo:false,
                encabezado:false,
                contenido:false,
                imagen:false
            },
            confirmarGuardar: false,
            confirmarEditar: false, 
            confirmarBorrar: false,
            idBorrar:'',
            imagenesGaleria:[],
            titulosUrl:[]
            
        })
    } 
    
    manejaEstado = (e) => {
        this.setState({estado: e.currentTarget.value});
    }

    archivoSeleccionado = (e) => {
        this.setState({
            imagen: e.target.files[0],
            srcImg: URL.createObjectURL(e.target.files[0]),

        })
    }

    manejaCambio = (e) => {
        const { name, value } = e.target;
        const largoNombre = 'largo'+name; 

        const largo = value.length; 
		this.setState({ [name]: value, [largoNombre]: largo});
    }





    /* funciones comunes para mensajes y validaciones */ 
    guardarEditarValidando = async ({validacion, confirmar}) =>{
        let validado = await validacion();

        if(validado.resultado){
            confirmar()
        }else{

            for (const k in validado.mensajes) {

                this.Notificaciones.addNotification({
                    message: validado.mensajes[k],
                    level: 'error',
                    position:'tr'
                });
                 
            }
    
        }  

    }

    mensajeGuardadoEditado = async ({resultado, mensaje, icono, tipo}) =>{
        if(resultado==="ok"){

            await this.cargarListado();
            this.estadoDefault();
            
            this.Notificaciones.addNotification({
                title: <FaSave/>,
                message: mensaje,
                level: 'success',
                position:'tr'
            });

        } else{
            this.Notificaciones.addNotification({
                message: 'Error inesperado, intentelo más tarde',
                level: 'error',
                position:'tr'
            });  
        }

        this.setState({cargando:false});   
    }


    validacionFormulario = async () => {
        let {titulo, encabezado, contenido, imagen, titulosUrl} = this.state;

        let vTitulo        = validarItem({valor:titulo, input:'Título', vacio:true, largo:90, repetido:{valor: Utils.espacioGuion(titulo), arreglo:titulosUrl}});
        let vEncabezado    = validarItem({valor:encabezado, input:'Encabezado', vacio:false, largo:230});
        let vContenido     = validarItem({valor:contenido, input:'Contenido', vacio:true, largo:2000});
        let vImagen        = validarItem({valor:imagen, input:'Imagen', archivo:true});


    
        this.setState({ validacion:{
            titulo:          !vTitulo.resultado, 
            encabezado:      !vEncabezado.resultado, 
            contenido:       !vContenido.resultado, 
            imagen:          !vImagen.resultado, 
        } });  
        
        let formulario = validarFormulario([vTitulo, vEncabezado, vContenido, vImagen]); 

        return formulario;

    }


    /* ingresar */

    muestraConfirmarGuardar = () => {
        this.setState(prevState => ({
            confirmarGuardar: !prevState.confirmarGuardar
        }));    
    }

    ingresarBlog = async () => {
        this.guardarEditarValidando({
            validacion: this.validacionFormulario,
            confirmar: this.muestraConfirmarGuardar   
        }); 
    }

    ingresarBlogBD = async () =>{
        this.setState({cargando:true});

        const {estado, titulo,  encabezado, contenido, imagen, galeria, usuario} = this.state;  
        let urlpath = Utils.espacioGuion(titulo); 
        let tituloEnviar = Utils.unEspacio(titulo); 
        let fecha = Fecha.Hoy();
        let resultado;
        if(galeria === null){
            resultado = await blog.ingresar(tituloEnviar, urlpath, encabezado, contenido, imagen, imagen.name, estado, fecha, usuario); 
        }else{    
            resultado = await blog.ingresarConGaleria(tituloEnviar, urlpath, encabezado, contenido, imagen, imagen.name, estado, fecha, usuario, galeria.id);
        }
        
        this.mensajeGuardadoEditado({resultado:resultado, mensaje: 'Blog ingresado correctamente'})

    }

 
    asociar = (b) => {
        this.setState({
            galeria : b
        }); 
        this.toggleModal2();
        
    }


    /* editar */

    muestraConfirmarEditar = () => {
        this.setState(prevState => ({
            confirmarEditar: !prevState.confirmarEditar
        }));    
    }

    editarBlog = async () => {
        this.guardarEditarValidando({
            validacion: this.validacionFormulario,
            confirmar: this.muestraConfirmarEditar   
        }); 
    }

    editarBlogBD = async () =>{
        this.setState({cargando:true});

        let {id, estado, titulo, encabezado, contenido, imagen, galeria, usuario} = this.state;
        let tituloEnviar = Utils.unEspacio(titulo); 
        let urlpath = Utils.espacioGuion(titulo); 
        let fecha = Fecha.Hoy();
        let galeria_id = galeria ? galeria.id : 0;

        let resultado;
        if(imagen){
            resultado = await blog.editar(id, tituloEnviar, urlpath, encabezado, contenido, imagen, imagen.name, estado, fecha, usuario, galeria_id);
        }else{
            resultado = await blog.editarSinImagen(id, tituloEnviar, urlpath, encabezado, contenido, estado, fecha, usuario, galeria_id);
        } 
   
        this.mensajeGuardadoEditado({resultado:resultado, mensaje: 'Blog editado correctamente'})

    }


    cargarEditar = (b) => {
  
        
        this.estadoDefault();
        let galeria = null;
        if(b.galeria_id !== "0"){
            galeria = { id: b.galeria_id, nombre: b.nombre, url: b.url }
        }
        this.setState({
            id: b.id, 
            estado:b.estado,
            titulo:b.titulo,
            encabezado:b.encabezado,
            contenido:b.contenido,
            srcImg:UrlBase+b.imagen,
            galeria: galeria,
            imagen: false
        }); 

      
        
    }



    /* borrar */


    muestraConfirmarBorrar = (id) => {
        this.setState((prevState) => ({
            confirmarBorrar: !prevState.confirmarBorrar,
            idBorrar: id
        }));          
    }


    eliminarBlog = async () => {
        this.setState({cargando:true});
        
        let resultado = await blog.eliminar(this.state.idBorrar)

        if(resultado==="ok"){
            await this.cargarListado();
            
            this.Notificaciones.addNotification({
                title: <FaTrashAlt/>,
                message: 'Blog eliminado satisfactoriamente',
                level: 'info',
                position:'tr'
            });
        }else{
            this.Notificaciones.addNotification({
                message: 'Error inesperado, intentelo más tarde',
                level: 'error',
                position:'tr'
            });          
        }

       
        this.setState({cargando:false});
    }


    
    cargarListado = async () => {
        let titulos = [];
        let resultado = await blog.mostrar(); 
   
        for (const t in resultado) {
            titulos.push(Utils.espacioGuion(resultado[t].titulo)); 
        }

        this.setState({data: resultado, titulosUrl:titulos, cargando:false}); 
    }

    eliminarGaleria = () => {
        this.setState({ galeria: null })
    }
    
    visualizar = (b) => {
        this.setState({entrada:b})
        this.imagenesGaleria(b.galeria_id);
        this.toggleModal();
    }

    visualizarGaleria = async () => {
        let resultado = await galeria.mostrar(); 
        this.setState({galerias: resultado});
        this.toggleModal2();
    }

    toggleModal = () => {
        this.setState(prevState => ({
          modal: !prevState.modal
        })); 
    }

    toggleModal2 = () => {
        this.setState(prevState => ({
          modal2: !prevState.modal2
        })); 
    } 

    imagenesGaleria = async (id) => {
        let resultado = await galeria.imagenes(id);
        if (resultado!==null && resultado!== undefined && resultado.length>0) {
            this.setState({imagenesGaleria:resultado}); 
        }      
    }
 


    componentDidMount() {
        this.cargarListado();

    }

    render() {
        const {id, estado, srcImg, titulo, encabezado, contenido, data, entrada, galeria, galerias, largotitulo, largoencabezado, largocontenido, cargando, confirmarGuardar, confirmarEditar, confirmarBorrar, validacion, imagenesGaleria} = this.state; 
        return (
            <Page title="Administrador del blog" breadcrumbs={[ { name: 'Noticias', active: true } ]}>
                 <Cargando valor={cargando}/>
                <Card>
                    <CardHeader>Detalle entrada del blog</CardHeader>
                    <CardBody>     
                        <div className="switch-field espacio">
                            <input type="radio" id="switch_izq2" name="modo" value="borrador"  checked={estado==='borrador'} onChange={this.manejaEstado}/>
                            <label htmlFor="switch_izq2">Estado borrador</label>
                            <input type="radio" id="switch_der2" name="modo" value="publicada" checked={estado==='publicada'}  onChange={this.manejaEstado}/>
                            <label htmlFor="switch_der2">Estado publicada</label>
                        </div>   
                        <Row className="no-margin-bottom">
                            <Col  xl={3} lg={3} md={6} sm={12}>
                                <FormGroup>
                                    <Label>Título</Label>
                                    <Input
                                        type="text"
                                        name="titulo"
                                        value={titulo}
                                        onChange={this.manejaCambio}
                                        invalid={validacion.titulo}
                                        maxLength={90}
                                    />
                                    <span className={largotitulo>90 ? 'color-rojo' : null}>{largotitulo} / 90</span>
                                </FormGroup>
                            </Col>
                            <Col  xl={9} lg={9} md={6} sm={12}>
                                <FormGroup>
                                    <Label >Resumen - Encabezado</Label>
                                    <Input
                                        type="text"
                                        name="encabezado"
                                        value={encabezado}
                                        onChange={this.manejaCambio}
                                        invalid={validacion.encabezado}
                                        maxLength={230}
                                    />
                                    <span className={largoencabezado>230 ? 'color-rojo' : null}>{largoencabezado} / 230</span>
                                </FormGroup>
                            </Col>
                            <Col  sm={12}>
                                <FormGroup>
                                    <Label >Contenido</Label>
                                    <Input
                                        type="textarea"
                                        className="intextarea"
                                        name="contenido"
                                        value={contenido}
                                        onChange={this.manejaCambio}
                                        invalid={validacion.contenido}
                                        maxLength={2000}
                                    />
                                    <span className={largocontenido>2000 ? 'color-rojo' : null}>{largocontenido} / 2000</span>
                                </FormGroup>
                            </Col>
                            <Col  sm={12}>
                                <hr/>
                                <FormGroup>
                                    <Label >Foto principal:</Label>
                                    <Input
                                        id="input"
                                        type="file"
                                        onChange={this.archivoSeleccionado}
                                    />
                                    <br/>
                                    <br />
                                    {srcImg!=='' && srcImg!==null ? 
                                        <img src={srcImg} className="imagen bloque-centro" alt=""/>
                                        : <div className={validacion.imagen?"sin-registros in-error": "sin-registros"}>Sin imagen principal</div>
                                    } 
                                    <hr/>

                                    <Label className="sep-cuerpo">Galería asociada: <br/>
                                        <span className="subt-cuerpo">Para crear o editar galerías de imágenes, dirigirse al módulo de galerías</span>
                                    </Label>
                                   
                                    {            
                                        galeria !== null ?

                                        <div className="borde-suave  galeria-asociada">
                                            <div className="destacado-cuerpo">
                                                <span >{galeria.nombre!=="" && galeria.nombre!==undefined?galeria.nombre : "Galería sin nombre"}</span> 
                                       
                                            </div>
                            
                                            <div className="dzu-previewContainer">
                                                {
                                                    galeria.url!==null && galeria.url!=="" ? 
                                                    <img src={UrlBase+galeria.url} alt="" className="dzu-previewImage"></img>
                                                    : <span>Sin imágenes</span>
                                                }
                                                
                                                <div className="dzu-previewStatusContainer">
                                                <Button color="danger" className="btn-tabla" onClick={()=>this.eliminarGaleria()}><FaTimes/></Button>
                                                </div>
                                            </div>
                                       
                                        </div>

                                        : <div className="sin-registros galeria-asociada">Sin galería asociada</div>

                                        

                                    }
                                    <Button color="secondary" size="sm" className="btnlado" onClick={()=>this.visualizarGaleria()}>
                                    <FaImage/> {galeria !== null ? "Cambiar galería asociada": "Asociar Galeria"}
                                    </Button>
                                </FormGroup>
                            </Col>
                        </Row>
                    </CardBody>                    
                    <Botonera 
                        valor={id}
                        ingresar={this.ingresarBlog}
                        editar={this.editarBlog}
                        cancelar={this.estadoDefault}
                    />            
                </Card>
                <br/>
                <TablaBlog 
                    data={data}
                    editar={this.cargarEditar}
                    visualizar={this.visualizar }
                    eliminar={this.muestraConfirmarBorrar}
                    cargarListado={this.cargarListado}
                />
                <ModalBlog 
                    isOpen={this.state.modal} 
                    toggle={this.toggleModal} 
                    entrada={entrada}
                    galeria={imagenesGaleria}
                />
                <ModalBlogGaleria
                    isOpen={this.state.modal2} 
                    toggle={this.toggleModal2} 
                    data={galerias}
                    asociar={this.asociar}
                />





                <Confirmar 
                    isOpen={confirmarGuardar} 
                    toggle={this.muestraConfirmarGuardar} 
                    texto={"¿Esta seguro de guardar el blog?"} 
                    funcion={this.ingresarBlogBD} 
                />

                 <Confirmar 
                    isOpen={confirmarEditar} 
                    toggle={this.muestraConfirmarEditar} 
                    texto={"¿Esta seguro de editar el blog?"} 
                    funcion={this.editarBlogBD} 
                />

                 <Confirmar 
                    isOpen={confirmarBorrar} 
                    toggle={this.muestraConfirmarBorrar} 
                    texto={"¿Esta seguro de borrar el blog?"} 
                    funcion={this.eliminarBlog} 
                />


                <Notificaciones
                    dismissible={false}
                    ref={Notificaciones =>
                        (this.Notificaciones = Notificaciones)
                    }
                    style={NOTIFICATION_SYSTEM_STYLE}
                    />
        







            </Page>
        )
    }
};
export default GestorBlog;
